import fontawesome from '@fortawesome/fontawesome';
import {
  faUserMd,
  faBuilding,
  faUsers,
  faTasks,
  faHandPaper,
  faDoorOpen,
  faAngleLeft,
  faAngleRight,
  faSortUp,
  faSortDown,
  faFilePdf,
  faCheck,
  faBars,
  faSyncAlt,
  faPlus,
  faEye,
  faEyeSlash,
  faFilter,
  faCopy
} from '@fortawesome/free-solid-svg-icons';
import {
  faMap,
  faUserCircle,
  faEdit
} from '@fortawesome/free-regular-svg-icons';

const FaService = {
  init() {
    fontawesome.library.add(
      faUserCircle,
      faUserMd,
      faBuilding,
      faUsers,
      faTasks,
      faHandPaper,
      faDoorOpen,
      faMap,
      faAngleLeft,
      faAngleRight,
      faSortUp,
      faSortDown,
      faFilePdf,
      faCheck,
      faBars,
      faSyncAlt,
      faPlus,
      faEye,
      faEyeSlash,
      faEdit,
      faFilter,
      faCopy
    );
  }
};

export default FaService;
